import { FunctionalComponent, h } from "@stencil/core";
import { IconThumbnail } from "../types";

interface ThumbnailProps extends IconThumbnail {
    onDetailsClick: (icon: IconThumbnail) => void;
    assetsPath: string;
    selected: boolean;
}

export const IconLibraryThumbnail: FunctionalComponent<ThumbnailProps> = ({
    iconName,
    iconDescription,
    iconWeight,
    filled,
    onDetailsClick,
    selected,
    assetsPath
}) => {
    const baseClass = "ux-icon-library-thumbnail";
    const isWebTheme = assetsPath.includes("web");
    return (
        <div
            class={{
                [baseClass]: true,
                [`${baseClass}--is-selected`]: selected
            }}
            key={iconName + iconWeight}
            data-icon={iconName + iconWeight}
        >
            <div class={`${baseClass}__action-buttons ux-button-group ux-button-group--with-spacing`}>
                <a
                    class="ux-button ux-button--icon-only ux-u-margin-left-20"
                    download=""
                    title="Download icon"
                    href={`${assetsPath + iconName + (filled ? `--filled` : ``)}--${iconWeight}.svg`}
                >
                    <ux-icon name={isWebTheme ? "chevron-download" : "chevron-down"} weight="normal"></ux-icon>
                </a>
                <button
                    class="ux-button ux-button--icon-only"
                    onClick={() =>
                        onDetailsClick({
                            iconName,
                            iconDescription,
                            iconWeight,
                            filled
                        })
                    }
                >
                    <ux-icon name={isWebTheme ? "book" : "square-info"} weight="normal"></ux-icon>
                </button>
            </div>
            <div class={`${baseClass}__container`}>
                <ux-icon name={iconName} weight={iconWeight} filled={filled}></ux-icon>
                <div class={`${baseClass}__name`}>{iconName}</div>
                <span class={`${baseClass}__weight`}>{iconWeight}</span>
            </div>
            <div class={`${baseClass}__description ux-text-normal ux-text-normal--light-gray`}>{iconDescription}</div>
        </div>
    );
};
